import { AnonRequestNewInviteRepository } from '@/modules/auth/infra/repositories'
import { makeAnonEdgeHttpClient } from '@/main/factories/http'
import type { RequestNewInvite } from '@/modules/auth/use-cases'

export function makeRequestNewInvite(): RequestNewInvite {
  return new AnonRequestNewInviteRepository(makeAnonEdgeHttpClient()).execute
}
